import { render, staticRenderFns } from "./AdminBillings.vue?vue&type=template&id=09ddf029&scoped=true&"
import script from "./AdminBillings.vue?vue&type=script&lang=js&"
export * from "./AdminBillings.vue?vue&type=script&lang=js&"
import style0 from "./AdminBillings.vue?vue&type=style&index=0&id=09ddf029&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ddf029",
  null
  
)

export default component.exports